import { render, staticRenderFns } from "./RemarkAttachments.vue?vue&type=template&id=2db6ad41&scoped=true"
import script from "./RemarkAttachments.vue?vue&type=script&lang=js"
export * from "./RemarkAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db6ad41",
  null
  
)

export default component.exports